module.exports = __webpack_public_path__ + "img/case-studies6.9aeb168e.jpg";